module.exports = __webpack_public_path__ + "static/img/photo16.ca4a4e53.jpg";